import { ISidebarPageItem } from "#src/layoutV2/types";
import {
  generatePath,
  Link,
  matchPath,
  UIMatch,
  useParams,
} from "react-router-dom";
import { twMerge } from "tailwind-merge";

export const SidebarPageItemRender = ({
  page,
  pathMatches,
  overwriteClassName,
}: {
  page: ISidebarPageItem;
  pathMatches: UIMatch[];
  overwriteClassName?: string;
}) => {
  const active = Boolean(
    pathMatches.some((match) => matchPath(page.path, match.pathname))
  );

  const params = useParams();

  return (
    <Link
      to={generatePath(page.redirect ? page.redirect : page.path, params)}
      className={twMerge(
        "py-2 pl-[2.625rem] pr-3 my-0.5 no-underline text-md font-semibold rounded-md transition-all",
        active
          ? "bg-brand-v2-50 text-brand-v2-700"
          : "hover:bg-gray-v2-50 text-gray-v2-700 hover:text-gray-v2-700",
        overwriteClassName
      )}
    >
      {page.getLabel()}
    </Link>
  );
};
